import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import clsx from 'clsx';

const overrideStyle = makeStyles((theme) => ({
    root: {
      textTransform: 'none',
      borderRadius: 8,
      padding: 10,
      height: 40,
      boxSizing: 'border-box',
      minWidth: 40
    },
    error: {
      color: theme.palette.error.main,
      backgroundColor: theme.palette.error.light
    }
  }), {name: "RaymanButton"});

function RaymanButton({...props})
{
    const classes = overrideStyle();
    const color =  props.color ? props.color : "primary";
    
    return <Button fullWidth disableElevation variant="contained" {...props} color={color !== "error" ? color : undefined} className={clsx(classes.root, props.color === "error" && classes.error, props.className)}/>
}

  export default RaymanButton;